import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import ProjectDetails from './ProjectDetails';

export default function BulkUnarchive({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Unarchive"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects()
          .bulkSetRecordStatus(ids, { recordStatusId: 'active' })
          .then((r) => r.data)
      }
      renderRow={ProjectDetails}>
      {`Are you sure you want to unarchive ${ids.length} ${pluralize('project', ids.length)}? If any associated client is archived, it will also be unarchived.`}
    </BulkActionModal>
  );
}
